import {createAsyncThunk, createEntityAdapter, createSlice} from '@reduxjs/toolkit';
import {sourceTypesApi} from "../Constructor/periodValuesFilterApi";
import {codeObject, datasourceObject, defaultConstructor, stnEntity} from "./common/constructorObject";


function findIndexByRowId(arr, rowId) {
    for (let i=0; i<arr.length; i++) {
        if (arr[i].rowId == rowId) {
            return i
        }
    }

    return -1;
}

export const fillDecadeAction = createAsyncThunk('fillDecadeAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const setDuplicationTypeAction = createAsyncThunk('setDuplicationTypeAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const setDuplicationAction = createAsyncThunk('setDuplicationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const setDecadeTemplateNameAction = createAsyncThunk('setDecadeTemplateNameAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const setTTTemplateNameAction = createAsyncThunk('setTTTemplateNameAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const setWithoutDaysAction = createAsyncThunk('setWithoutDaysAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectStationAction = createAsyncThunk('selectStationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectTTStationAction = createAsyncThunk('selectTTStationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectDatasourceTypeAction = createAsyncThunk('selectDatasourceTypeAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectTTDatasourceTypeAction = createAsyncThunk('selectTTDatasourceTypeAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectDatasourceAction = createAsyncThunk('selectDatasourceAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectEntityAction = createAsyncThunk('selectEntityAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectTTEntityAction = createAsyncThunk('selectTTEntityAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectTTDatasourceAction = createAsyncThunk('selectTTDatasourceAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectCodeAction = createAsyncThunk('selectCodeAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectTTCodeAction = createAsyncThunk('selectTTCodeAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectOperationAction = createAsyncThunk('selectOperationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectDecadeOperationAction = createAsyncThunk('selectDecadeOperationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectResultOperationAction = createAsyncThunk('selectResultOperationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const selectTTResultOperationAction = createAsyncThunk('selectTTResultOperationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const deselectDecadeOperationAction = createAsyncThunk('deselectDecadeOperationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const deselectResultOperationAction = createAsyncThunk('deselectResultOperationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const deselectTTResultOperationAction = createAsyncThunk('deselectTTResultOperationAction', (payload) => ({
    type: 'constructors',
    payload,
}))

export const deleteRowAction = createAsyncThunk('deleteRowAction', (payload) => ({
    type: 'constructors',
    payload
}))

export const deleteTTRowAction = createAsyncThunk('deleteTTRowAction', (payload) => ({
    type: 'constructors',
    payload
}))


export const CONSTRUCTOR_SLICE = 'constructors';

const constructorsAdapter = createEntityAdapter();
const constructorsSlice = createSlice({
    name: CONSTRUCTOR_SLICE,
    initialState: constructorsAdapter.getInitialState({
        temporaryTurn: {...defaultConstructor},
        decade: {...defaultConstructor}
    }),
    reducers: {
        setNewDecadeConstructor: (state, action) => {
            state.decade = action.payload
        },
        setNewTTConstructor: (state, action) => {
            state.temporaryTurn = action.payload
            state.temporaryTurn.type = 'TT'
        },
        toggleShowConstructorPanel: (state) => {
            Object.assign(state, { showConstructorsPanel: !state.showConstructorsPanel });
        },
        toggleShowCalculationsPanel: (state) => {
            Object.assign(state, { showCalculationsPanel: !state.showCalculationsPanel });
        },
        setAllRows: (state, action) => {
            state.decade.filtersRows = action.payload
            state.decade.curRowNum = action.payload.length
        },
        setEditable: (state, action) => {
            state.decade.editable = action.payload
        },
        setTTEditable: (state, action) => {
            state.temporaryTurn.editable = action.payload
        },
        addFiltersRow: (state) => {
            const rows = state.decade.filtersRows
            const copiedRow = JSON.parse(JSON.stringify(rows[rows.length-1])); //way to make deep copy
            copiedRow.rowId = Number(state.decade.curRowNum);
            copiedRow.code = {...codeObject};
            copiedRow.stnEntity = {...stnEntity}
            copiedRow.operation = '';
            copiedRow.decadeOperation = '';
            state.decade.curRowNum += 1;

            rows.push(copiedRow)
        },
        addTTFilterRow: (state) => {
            const rows = state.temporaryTurn.filtersRows
            const newRow = {}
            Object.assign(newRow, rows[rows.length-1])
            rows.push(newRow)
            rows[rows.length-1].rowId = Number(state.temporaryTurn.curRowNum);
            rows[rows.length-1].code = {...codeObject};
            rows[rows.length-1].stnEntity = {...stnEntity}
            rows[rows.length-1].operation = 'SUM';
            rows[rows.length-1].decadeOperation = '';
            state.temporaryTurn.curRowNum += 1;

            Object.assign(state.temporaryTurn.filtersRows, rows);
        }
    },
    extraReducers: {
        [selectStationAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            state.decade.type = 'DECADE'
            Object.assign(state.decade.station, payload)
        },
        [selectTTStationAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            state.temporaryTurn.type = 'TT'
            Object.assign(state.temporaryTurn.station, payload)
        },
        [setDecadeTemplateNameAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            state.decade.name = payload
        },
        [setTTTemplateNameAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            state.temporaryTurn.name = payload
        },
        [selectDatasourceTypeAction.fulfilled]: (state, action) => {
            const {payload} = action.payload

            let index;
            if (payload.rowId == undefined || payload.rowId === "") {
                index = state.decade.filtersRows[state.decade.filtersRows.length-1].rowId
            } else {
                index = findIndexByRowId(state.decade.filtersRows, payload.rowId)
            }

            const rows = state.decade.filtersRows

            rows[index].code = {...codeObject};
            rows[index].operation = '';
            rows[index].decadeOperation = '';
            state.decade.filtersRows[index].type = payload.res
        },
        [selectEntityAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            let index;
            if (payload.rowId == undefined || payload.rowId === "") {
                index = state.decade.filtersRows[state.decade.filtersRows.length-1].rowId
            } else {
                index = findIndexByRowId(state.decade.filtersRows, payload.rowId)
            }
            const rows = state.decade.filtersRows
            rows[index].operation = ''
            state.decade.filtersRows[index].stnEntity = payload.res
        },
        [selectTTEntityAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            let index;
            if (payload.rowId == undefined || payload.rowId === "") {
                index = state.temporaryTurn.filtersRows[state.temporaryTurn.filtersRows.length-1].rowId
            } else {
                index = findIndexByRowId(state.temporaryTurn.filtersRows, payload.rowId)
            }
            const rows = state.temporaryTurn.filtersRows
            rows[index].operation = ''
            state.temporaryTurn.filtersRows[index].stnEntity = payload.res
        },
        [selectTTDatasourceTypeAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            console.log(payload)
            const index = findIndexByRowId(state.temporaryTurn.filtersRows, payload.rowId)
            const rows = state.temporaryTurn.filtersRows

            rows[index].datasource = {...datasourceObject};
            rows[index].code = {...codeObject};
            rows[index].operation = 'SUM';
            rows[index].decadeOperation = '';

            Object.assign(state.temporaryTurn.filtersRows[index].type, payload.res)
        },
        [selectDatasourceAction.fulfilled]: (state, action) => {
            const {payload} = action.payload


            let index;
            if (payload.rowId == undefined || payload.rowId === "") {
                index = state.decade.filtersRows[state.decade.filtersRows.length-1].rowId
            } else {
                index = findIndexByRowId(state.decade.filtersRows, payload.rowId)
            }


            const copiedDatasource = JSON.parse(JSON.stringify(payload.res));
            state.decade.filtersRows[index].datasource = copiedDatasource
        },
        [selectTTDatasourceAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            const index = findIndexByRowId(state.temporaryTurn.filtersRows, payload.rowId)

            Object.assign(state.temporaryTurn.filtersRows[index].datasource, payload.res)
        },
        [deleteRowAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            const index = findIndexByRowId(state.decade.filtersRows, payload.rowId)
            state.decade.filtersRows.splice(index, 1)
        },
        [deleteTTRowAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            const index = findIndexByRowId(state.temporaryTurn.filtersRows, payload.rowId)
            state.temporaryTurn.filtersRows.splice(index, 1)
        },
        [selectCodeAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            let index;
            if (payload.rowId == undefined || payload.rowId === "") {
                index = state.decade.filtersRows[state.decade.filtersRows.length-1].rowId
            } else {
                index = findIndexByRowId(state.decade.filtersRows, payload.rowId)
            }
            Object.assign(state.decade.filtersRows[index].code, payload.res)
        },
        [selectTTCodeAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            const index = findIndexByRowId(state.temporaryTurn.filtersRows, payload.rowId)
            Object.assign(state.temporaryTurn.filtersRows[index].code, payload.res)
        },
        [selectOperationAction.fulfilled]: (state, action) => {
            const {payload} = action.payload
            const index = findIndexByRowId(state.decade.filtersRows, payload.rowId)

            state.decade.filtersRows[index].operation = payload.res
        },
        [selectDecadeOperationAction.fulfilled]: (state, action) => {
            const payload = action.payload
            state.decade.decadeOperations.push(payload.payload)
        },
        [selectResultOperationAction.fulfilled]: (state, action) => {
            const payload = action.payload
            state.decade.tableOperations.push(payload.payload)
        },
        [selectTTResultOperationAction.fulfilled]: (state, action) => {
            const payload = action.payload
            state.temporaryTurn.tableOperations.push(payload.payload)
        },
        [deselectDecadeOperationAction.fulfilled]: (state, action) => {
            const payload = action.payload
            const index = state.decade.decadeOperations.map(el => el.code).indexOf(payload.payload)
            state.decade.decadeOperations.splice(index, 1)
        },
        [deselectResultOperationAction.fulfilled]: (state, action) => {
            const payload = action.payload
            const index = state.decade.tableOperations.map(el => el.code).indexOf(payload.payload)
            state.decade.tableOperations.splice(index, 1)
        },
        [deselectTTResultOperationAction.fulfilled]: (state, action) => {
            const payload = action.payload
            const index = state.temporaryTurn.tableOperations.map(el => el.code).indexOf(payload.payload)
            state.temporaryTurn.tableOperations.splice(index, 1)
        },
        [setDuplicationAction.fulfilled]: (state, action) => {
            const payload = action.payload
            state.decade.multiplyDimension = payload.payload
        },
        [setDuplicationTypeAction.fulfilled]: (state, action) => {
            const payload = action.payload
            if (payload.payload !== "NONE") {
                state.decade.duplicationType = payload.payload
                state.decade.multiplyDimension = true
            } else {
                state.decade.duplicationType = "NONE"
                state.decade.multiplyDimension = false
            }
        },
        [setWithoutDaysAction.fulfilled]: (state, action) => {
            const payload = action.payload
            state.decade.withoutDays = payload.payload
        },
        [fillDecadeAction.fulfilled]: (state, action) => {
            const payload = action.payload.payload
            console.log(JSON.stringify(payload))

            state.decade.station = payload.station
            state.decade.decadeOperations = payload.decadeOperations
            state.decade.tableOperations = payload.tableOperations
            state.decade.filtersRows = payload.reportTemplateFilters
            state.decade.duplicationType = payload.duplicationType
            state.decade.multiplyDimension = payload.multiplyDimension
            state.decade.withoutDays = payload.withoutDays
        }
    },
});

export default constructorsSlice.reducer;

export const constructorsPanelShowSelector = (state) => state.constructors?.showConstructorsPanel;
export const calculationsPanelShowSelector = (state) => state.constructors?.showCalculationsPanel;

export const {
    setTTEditable,
    setNewTTConstructor,
    setNewDecadeConstructor,
    setEditable,
    setAllRows,
    addFiltersRow,
    addTTFilterRow,
    toggleShowConstructorPanel,
    toggleShowCalculationsPanel
} = constructorsSlice.actions;


